<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'
</script>
<template>
  <UiSectionWrapper
    title="Kelola Pengiriman Toko WooCommerce dengan Plugin Ongkos Kirim & Cek Resi KiriminAja"
    sub-title="Plugin Ongkir & Cek Resi WooCommerce"
    description="Optimalkan ongkos kirim dan cek resi KiriminAja dengan plugin WooCommerce."
    hero-image="/images/plugin/woocommerce/cta.webp"
    class="bg-primary-container dark:bg-surface-container-high py-10 lg:py-0"
    image-class="hidden lg:block"
  >
    <template #action>
      <div class="flex items-center gap-2 lg:gap-4 py-2">
        <UiButton
          :to="
            $utm.utmUrl(
              WEB_APP_URL +
                '/register?redirectTo=/settings/api-request?plugin=woocommerce'
            )
          "
          label="Install Plugin"
          target="_blank"
          icon="material-symbols:download"
        />
        <UiButton
          :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
          label="Hubungi Kami"
          variant="primaryOutline"
          icon="material-symbols:call-outline"
        />
      </div>
    </template>
  </UiSectionWrapper>
</template>
